/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2020-09-29 08:41:08
 */
export class UtilsManager {
  // 处理日期
  formateDateToZh (date: any, formate = '/'): string {
    if (date === '' || date === undefined || date === null) {
      return ''
    }
    let time
    if (date.indexOf('+') >= 0) {
      const array = date.split('+')
      time = new Date(Date.parse(array[0] + 'Z'))
    } else {
      time = new Date(Date.parse(date + 'Z'))
    }
    time.setTime(time.setHours(time.getHours() + 8))

    const Y = time.getFullYear() + formate
    const M = String(time.getMonth() + 1).padStart(2, '0') + formate
    const D = String(time.getDate()).padStart(2, '0')
    return Y + M + D
  }

  getCurrentTimeZh (): string {
    const date = new Date()
    const obj = {
      year: date.getFullYear(),
      month: String(date.getMonth() + 1).padStart(2, '0'),
      day: String(date.getDate()).padStart(2, '0'),
      hours: String(date.getHours()).padStart(2, '0'),
      minits: String(date.getMinutes()).padStart(2, '0'),
      seconds: String(date.getSeconds()).padStart(2, '0')
    }
    return `${obj.year}-${obj.month}-${obj.day} ${obj.hours}:${obj.minits}:${obj.seconds}`
  }

  formatSeconds = (value: number) => {
    const h = Math.floor(value / 3600) < 10 ? '0' + Math.floor(value / 3600) : Math.floor(value / 3600)
    const m = Math.floor((value / 60 % 60)) < 10 ? '0' + Math.floor((value / 60 % 60)) : Math.floor((value / 60 % 60))
    const s = Math.floor((value % 60)) < 10 ? '0' + Math.floor((value % 60)) : Math.floor((value % 60))
    return h + ':' + m + ':' + s
  }

  timeToSec = (time: string) => {
    let s = 0
    const hour = parseInt(time.split(':')[0])
    const min = parseInt(time.split(':')[1])
    const sec = parseInt(time.split(':')[2])
    s = Number(hour * 3600) + Number(min * 60) + Number(sec)
    return s
  }

  paramToObj = (url: string) => {
    const search = url.split('?')[1]
    if (!search) {
      return {}
    }
    return JSON.parse(
      '{"' +
        decodeURIComponent(search)
          .replace(/"/g, '\\"')
          .replace(/&/g, '","')
          .replace(/=/g, '":"')
          .replace(/\+/g, ' ') +
        '"}'
    )
  }

  parseTime = (
    time?: object | string | number | null,
    cFormat?: string
  ): string | null => {
    if (time === undefined || !time) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date: Date
    if (typeof time === 'object') {
      date = time as Date
    } else {
      if (typeof time === 'string') {
        if (/^[0-9]+$/.test(time)) {
          // support "1548221490638"
          time = parseInt(time)
        } else {
          // support safari
          // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
          time = time.replace(new RegExp(/-/gm), '/')
        }
      }
      if (typeof time === 'number' && time.toString().length === 10) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj: { [key: string]: number } = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const timeStr = format.replace(/{([ymdhisa])+}/g, (result, key) => {
      const value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value]
      }
      return value.toString().padStart(2, '0')
    })
    return timeStr
  }

  judgeIsMobile = () => {
    const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    console.log('flag: ', flag)
    if (flag) {
      return true
    } else {
      return false
    }
  }
}
const utilsManager = new UtilsManager()
export default utilsManager
